import React from 'react'

import { FaStar } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

import { PersonCard, Section } from '../../../_components'
import { InstructorsGrid, TeamStatus } from '../styles'

import type { InstructorSummary } from './types'

interface InstructorTeamProps {
  instructors: InstructorSummary[]
  loading?: boolean
}

const InstructorTeam = ({
  instructors,
  loading = false,
}: InstructorTeamProps) => {
  const navigate = useNavigate()

  return (
    <Section
      title="Tu equipo docente"
      subtitle="Profesionales que acompañan tu progreso."
    >
      {loading ? (
        <TeamStatus role="status">Cargando equipo docente…</TeamStatus>
      ) : instructors.length === 0 ? (
        <TeamStatus>No hay profesores disponibles en este momento.</TeamStatus>
      ) : (
        <InstructorsGrid>
          {instructors.map((instructor) => (
            <PersonCard
              key={instructor.id}
              name={instructor.name}
              description={instructor.description}
              descriptionIcon={<FaStar aria-hidden="true" />}
              image={instructor.image}
              imageAlt={`Foto de ${instructor.name}`}
              tags={instructor.classTypes}
              actionLabel={`Ver perfil de ${instructor.name}`}
              onAction={() => navigate(instructor.profilePath)}
            />
          ))}
        </InstructorsGrid>
      )}
    </Section>
  )
}

export default InstructorTeam
